module.exports = __webpack_public_path__ + "img/柚子8.dda05f88.png";